import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { PurgeSettings, CreateOrUpdatePurgeSettingsDto } from 'types';

export const updatePurgeSettings = ({
  data,
}: {
  data: CreateOrUpdatePurgeSettingsDto;
}): Promise<PurgeSettings> => {
  return axios.put(`/api/purge`, data);
};

type UseUpdatePurgeSettingsOptions = {
  config?: MutationConfig<typeof updatePurgeSettings>;
};

export const useUpdatePurgeSettings = ({
  config,
}: UseUpdatePurgeSettingsOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousPurgeSettings) {
        queryClient.setQueryData(
          ['purgeSettings'],
          context.previousPurgeSettings
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['purgeSettings']);
    },
    ...config,
    mutationFn: updatePurgeSettings,
  });
};
